// SoumissionPro - Extension exhaustive du catalogue de matériaux
// Ajout massif d'items pour couvrir tous les secteurs résidentiels et commerciaux
// Prix CAD 2026, moyennes Home Depot / Rona / Patrick Morin / Lowe's

export const FR_EXTRAS = {
  'Rénovation cuisine': [
    { name: 'Robinet à commande tactile', unit: 'un', price: 480 },
    { name: 'Évier de ferme (apron) 30"', unit: 'un', price: 580 },
    { name: 'Évier composite quartz double', unit: 'un', price: 520 },
    { name: 'Mitigeur monocommande haut de gamme', unit: 'un', price: 580 },
    { name: 'Cuisinière à induction', unit: 'un', price: 2200 },
    { name: 'Cuisinière double four', unit: 'un', price: 2800 },
    { name: 'Réfrigérateur 3 portes French door', unit: 'un', price: 2850 },
    { name: 'Réfrigérateur encastré 30"', unit: 'un', price: 4500 },
    { name: 'Refroidisseur à vin encastré', unit: 'un', price: 1850 },
    { name: 'Tiroir-réchaud encastré', unit: 'un', price: 1450 },
    { name: 'Four mural simple 30"', unit: 'un', price: 1850 },
    { name: 'Four mural double', unit: 'un', price: 3200 },
    { name: 'Lave-vaisselle silencieux haut de gamme', unit: 'un', price: 1850 },
    { name: 'Robinet de remplissage par bouilloire', unit: 'un', price: 380 },
    { name: 'Distributeur d\'eau chaude instantanée', unit: 'un', price: 380 },
    { name: 'Compacteur de déchets', unit: 'un', price: 950 },
    { name: 'Broyeur alimentaire 3/4 HP', unit: 'un', price: 280 },
    { name: 'Caisson coulissant épices', unit: 'un', price: 220 },
    { name: 'Plateau tournant coin (lazy susan)', unit: 'un', price: 145 },
    { name: 'Tiroir intérieur sur mesure', unit: 'un', price: 95 },
    { name: 'Banc fenêtre encastré', unit: 'pi.lin.', price: 280 },
    { name: 'Crédence carreaux mosaïque', unit: 'pi.²', price: 32 },
    { name: 'Crédence pierre naturelle', unit: 'pi.²', price: 65 },
    { name: 'Plinthe chauffante électrique 4\'', unit: 'un', price: 95 },
    { name: 'Poubelle coulissante double', unit: 'un', price: 145 },
    { name: 'Coulisses pleine extension (paire)', unit: 'paire', price: 38 },
    { name: 'Panneau de finition d\'îlot', unit: 'un', price: 220 },
    { name: 'Évier de bar', unit: 'un', price: 180 },
    { name: 'Robinet cuisine noir mat', unit: 'un', price: 320 },
    { name: 'Comptoir porcelaine (Dekton)', unit: 'pi.²', price: 120 },
    { name: 'Organisateur d\'ustensiles en bois', unit: 'un', price: 48 },
    { name: 'Pattes d\'armoire réglables (lot 4)', unit: 'lot', price: 22 },
    { name: 'Valve d\'eau pour réfrigérateur', unit: 'un', price: 28 },
    { name: 'Moulure de caisson (fileur)', unit: 'pi.lin.', price: 18 },
  ],
  'Rénovation salle de bain': [
    { name: 'Trousse de plomberie complète douche', unit: 'kit', price: 380 },
    { name: 'Pomme de douche pluie 10"', unit: 'un', price: 220 },
    { name: 'Pomme de douche pluie 16"', unit: 'un', price: 480 },
    { name: 'Douchette portative à barre verticale', unit: 'un', price: 145 },
    { name: 'Mitigeur thermostatique 3 sorties', unit: 'un', price: 580 },
    { name: 'Banc de douche fixe', unit: 'un', price: 380 },
    { name: 'Bouton-poussoir purge bain', unit: 'un', price: 65 },
    { name: 'Niche encastrée douche', unit: 'un', price: 180 },
    { name: 'Barre d\'appui ADA 24"', unit: 'un', price: 65 },
    { name: 'Barre d\'appui ADA 36"', unit: 'un', price: 85 },
    { name: 'Plancher chauffant câbles 30 pi²', unit: 'kit', price: 480 },
    { name: 'Thermostat plancher chauffant Wi-Fi', unit: 'un', price: 220 },
    { name: 'Sèche-serviettes électrique', unit: 'un', price: 380 },
    { name: 'Étagère murale industrielle', unit: 'un', price: 95 },
    { name: 'Crochet à serviette double', unit: 'un', price: 18 },
    { name: 'Porte-papier hygiénique encastré', unit: 'un', price: 45 },
    { name: 'Brosse de toilette autoportante', unit: 'un', price: 28 },
    { name: 'Ventilateur avec lumière + Bluetooth', unit: 'un', price: 380 },
    { name: 'Miroir LED rétroéclairé 24x36', unit: 'un', price: 480 },
    { name: 'Miroir intelligent antibuée', unit: 'un', price: 750 },
    { name: 'Colonne de douche complète', unit: 'un', price: 480 },
    { name: 'Ensemble bain-douche 60"', unit: 'un', price: 950 },
    { name: 'Siège de douche rabattable', unit: 'un', price: 220 },
    { name: 'Renvoi et trop-plein de bain', unit: 'un', price: 85 },
    { name: 'Céramique murale métro 3x6', unit: 'pi.²', price: 6.5 },
    { name: 'Robinet lavabo cascade', unit: 'un', price: 220 },
    { name: 'Toilette compacte (10" rough-in)', unit: 'un', price: 380 },
    { name: 'Calfeutrant anti-moisissure salle de bain', unit: 'tube', price: 9 },
    { name: 'Drain de lavabo avec bouchon', unit: 'un', price: 32 },
    { name: 'Cadre de miroir sur mesure', unit: 'pi.lin.', price: 22 },
  ],
  'Toiture': [
    { name: 'Bardeau IKO Cambridge', unit: 'paquet', price: 42 },
    { name: 'Bardeau GAF Timberline HDZ', unit: 'paquet', price: 48 },
    { name: 'Membrane Henry Blueskin', unit: 'rouleau', price: 280 },
    { name: 'Membrane Soprema Soprastick', unit: 'rouleau', price: 220 },
    { name: 'Pare-vapeur PE 6mil 1500 pi²', unit: 'rouleau', price: 220 },
    { name: 'Solin extrémité 5"', unit: 'pi.lin.', price: 3.50 },
    { name: 'Larmier en aluminium 10\'', unit: 'pi.lin.', price: 2.80 },
    { name: 'Évent de plomberie 3"', unit: 'un', price: 28 },
    { name: 'Coiffe de cheminée inox', unit: 'un', price: 220 },
    { name: 'Gouttière aluminium 6"', unit: 'pi.lin.', price: 8.50 },
    { name: 'Descente gouttière aluminium', unit: 'pi.lin.', price: 5.50 },
    { name: 'Grille protection gouttière', unit: 'pi.lin.', price: 7 },
    { name: 'Soffite vinyle ventilé 12"', unit: 'pi.lin.', price: 5.50 },
    { name: 'Fascia aluminium 8"', unit: 'pi.lin.', price: 4.50 },
    { name: 'Coupe-feu blocs', unit: 'un', price: 22 },
    { name: 'Lattes de toit 1x4 traitées', unit: 'pi.lin.', price: 1.20 },
    { name: 'Réfection toit plat TPO', unit: 'pi.²', price: 12 },
    { name: 'Réfection toit plat EPDM', unit: 'pi.²', price: 10 },
    { name: 'Toiture métallique tuiles', unit: 'pi.²', price: 16 },
    { name: 'Bardeau d\'asphalte écologique recyclé', unit: 'paquet', price: 52 },
    { name: 'Bardeau de départ (rouleau)', unit: 'rouleau', price: 32 },
    { name: 'Bardeau de faîte', unit: 'paquet', price: 55 },
    { name: 'Turbine de ventilation de toit', unit: 'un', price: 85 },
    { name: 'Solin de puits de lumière', unit: 'kit', price: 180 },
    { name: 'Puits de lumière fixe 2x4', unit: 'un', price: 480 },
    { name: 'Planche de rive 1x8', unit: 'pi.lin.', price: 3.2 },
    { name: 'Ancrage de sécurité de toit', unit: 'un', price: 38 },
    { name: 'Membrane de sous-toiture ventilée', unit: 'rouleau', price: 185 },
  ],
  'Revêtement extérieur': [
    { name: 'Maibec déclin cèdre prépeint 6"', unit: 'pi.²', price: 8.50 },
    { name: 'Maibec Carrick prépeint', unit: 'pi.²', price: 7 },
    { name: 'Hardie Plank fibrociment', unit: 'pi.²', price: 7.50 },
    { name: 'Hardie Panel fibrociment', unit: 'pi.²', price: 8 },
    { name: 'Bardage vinyle haut de gamme', unit: 'pi.²', price: 4.50 },
    { name: 'Bardage vinyle texturé bois', unit: 'pi.²', price: 5.20 },
    { name: 'Bardage aluminium prélaqué', unit: 'pi.²', price: 9 },
    { name: 'Bardage acier prélaqué', unit: 'pi.²', price: 10 },
    { name: 'Bardage cèdre rouge naturel 1x6', unit: 'pi.²', price: 14 },
    { name: 'Bardage pin torréfié', unit: 'pi.²', price: 12 },
    { name: 'Brique de parement (palette)', unit: 'palette', price: 850 },
    { name: 'Pierre de parement naturelle', unit: 'pi.²', price: 18 },
    { name: 'Pierre de parement manufacturée', unit: 'pi.²', price: 12 },
    { name: 'Acrylique élastomère SAFI', unit: 'pi.²', price: 22 },
    { name: 'Stucco traditionnel 3 couches', unit: 'pi.²', price: 14 },
    { name: 'Panneau métallique architectural', unit: 'pi.²', price: 16 },
    { name: 'Lattis sous bardage cèdre', unit: 'pi.²', price: 1.20 },
    { name: 'Moulure de départ vinyle', unit: 'pi.lin.', price: 1.6 },
    { name: 'Linteau de fenêtre aluminium', unit: 'pi.lin.', price: 8 },
    { name: 'Allège de fenêtre (solin)', unit: 'pi.lin.', price: 6.5 },
    { name: 'Bloc de montage luminaire/prise', unit: 'un', price: 14 },
    { name: 'Panneau LP SmartSide', unit: 'pi.²', price: 6 },
    { name: 'Crépi de fondation (sac)', unit: 'sac', price: 22 },
    { name: 'Moustiquaire de soffite', unit: 'rouleau', price: 28 },
    { name: 'Fourrure métallique 7/8"', unit: 'pi.lin.', price: 1.4 },
  ],
  'Plancher': [
    { name: 'Chêne ingénierie 5" naturel', unit: 'pi.²', price: 7.50 },
    { name: 'Chêne massif 3¼" finition usine', unit: 'pi.²', price: 8.50 },
    { name: 'Érable ingénierie premium', unit: 'pi.²', price: 9 },
    { name: 'Vinyle LVT à coller', unit: 'pi.²', price: 4.50 },
    { name: 'Vinyle LVP click 8mm', unit: 'pi.²', price: 5.50 },
    { name: 'Vinyle LVP étanche SPC', unit: 'pi.²', price: 6.50 },
    { name: 'Stratifié 12mm AC4', unit: 'pi.²', price: 3.80 },
    { name: 'Bambou strand-woven', unit: 'pi.²', price: 7 },
    { name: 'Tuile céramique 12x24', unit: 'pi.²', price: 3.50 },
    { name: 'Mosaïque pierre naturelle', unit: 'pi.²', price: 18 },
    { name: 'Marbre Carrara dalle', unit: 'pi.²', price: 22 },
    { name: 'Granit dalle', unit: 'pi.²', price: 16 },
    { name: 'Béton poli scellé', unit: 'pi.²', price: 9 },
    { name: 'Liège naturel 4mm', unit: 'pi.²', price: 7 },
    { name: 'Sous-tapis acoustique 3mm', unit: 'pi.²', price: 1.20 },
    { name: 'Sous-tapis liège 6mm', unit: 'pi.²', price: 2.20 },
    { name: 'Membrane découplage Schluter Ditra', unit: 'pi.²', price: 3.20 },
    { name: 'Membrane chauffante Schluter', unit: 'pi.²', price: 8 },
    { name: 'Plinthes peintes blanches 4"', unit: 'pi.lin.', price: 3.50 },
    { name: 'Plinthe chêne massif 4½"', unit: 'pi.lin.', price: 5.50 },
    { name: 'Bande de transition métallique', unit: 'pi.lin.', price: 4 },
    { name: 'Colle pour LVT', unit: 'gallon', price: 65 },
    { name: 'Tapis berbère commercial', unit: 'vg.²', price: 28 },
    { name: 'Autolissant (sac 25 kg)', unit: 'sac', price: 42 },
    { name: 'Apprêt pour autolissant', unit: 'gallon', price: 55 },
    { name: 'Agrafes à plancher 18GA (boîte)', unit: 'boîte', price: 22 },
    { name: 'Nez de marche assorti', unit: 'un', price: 45 },
    { name: 'Scellant à coulis', unit: 'litre', price: 28 },
    { name: 'Grattage de colle (par pi²)', unit: 'pi.²', price: 1.5 },
    { name: 'Tuiles de garage PVC clipsables', unit: 'pi.²', price: 4.5 },
    { name: 'Contremarche en pin', unit: 'un', price: 18 },
  ],
  'Peinture': [
    { name: 'Sico Cashmere fini perle 3.78L', unit: 'gallon', price: 52 },
    { name: 'Benjamin Moore Aura 3.78L', unit: 'gallon', price: 85 },
    { name: 'Benjamin Moore Regal Select 3.78L', unit: 'gallon', price: 72 },
    { name: 'Sherwin Williams Emerald 3.78L', unit: 'gallon', price: 88 },
    { name: 'Sherwin Williams Cashmere 3.78L', unit: 'gallon', price: 65 },
    { name: 'Para Préparation P Plus 3.78L', unit: 'gallon', price: 48 },
    { name: 'Para Ultra (lavable) 3.78L', unit: 'gallon', price: 68 },
    { name: 'Apprêt scellant fixateur 3.78L', unit: 'gallon', price: 38 },
    { name: 'Apprêt bloquant tache shellac 3.78L', unit: 'gallon', price: 58 },
    { name: 'Peinture portes et boiseries semi-lustré 3.78L', unit: 'gallon', price: 68 },
    { name: 'Peinture plafond mat 3.78L', unit: 'gallon', price: 42 },
    { name: 'Peinture extérieure latex 3.78L', unit: 'gallon', price: 58 },
    { name: 'Teinture solide extérieure 3.78L', unit: 'gallon', price: 52 },
    { name: 'Teinture transparente 3.78L', unit: 'gallon', price: 48 },
    { name: 'Pinceau Wooster 2.5" angle', unit: 'un', price: 18 },
    { name: 'Pinceau Purdy 3" XL', unit: 'un', price: 26 },
    { name: 'Manchon rouleau Wagner microfibre 9"', unit: 'un', price: 9 },
    { name: 'Manchon rouleau mohair 9" finition', unit: 'un', price: 14 },
    { name: 'Plateau peinture jetable', unit: 'un', price: 4 },
    { name: 'Grille de bac rouleau', unit: 'un', price: 7 },
    { name: 'Ruban à masquer FrogTape 1.5" jaune', unit: 'rouleau', price: 14 },
    { name: 'Ruban à masquer 3M Scotch Blue 2"', unit: 'rouleau', price: 12 },
    { name: 'Bâche de plastique 9x12', unit: 'un', price: 5 },
    { name: 'Toile de protection plancher tissée', unit: 'rouleau', price: 38 },
    { name: 'Spatule masticage 2"', unit: 'un', price: 6 },
    { name: 'Composé léger 1 gal', unit: 'gallon', price: 18 },
    { name: 'Papier sablé 220 (paquet)', unit: 'paquet', price: 8 },
    { name: 'Bloc à sabler éponge', unit: 'un', price: 4 },
    { name: 'Calfeutrant peinturable latex', unit: 'tube', price: 6 },
    { name: 'Perche télescopique 4\'', unit: 'un', price: 22 },
    { name: 'Escabeau 6\' fibre de verre', unit: 'un', price: 145 },
    { name: 'Pistolet airless (location/jour)', unit: 'jour', price: 95 },
    { name: 'Enduit texturé pour plafond', unit: 'seau', price: 38 },
    { name: 'Rouleau à coin 4"', unit: 'un', price: 8 },
    { name: 'Filtre à peinture (paquet)', unit: 'paquet', price: 6 },
    { name: 'Mélangeur à peinture pour perceuse', unit: 'un', price: 9 },
    { name: 'Peinture tableau noir 1L', unit: 'pot', price: 28 },
  ],
  'Électricité': [
    { name: 'Panneau 100A 32 circuits Siemens', unit: 'un', price: 580 },
    { name: 'Panneau 200A 40 circuits Siemens', unit: 'un', price: 850 },
    { name: 'Sous-panneau 60A', unit: 'un', price: 220 },
    { name: 'Disjoncteur AFCI 20A', unit: 'un', price: 52 },
    { name: 'Disjoncteur AFCI/GFCI duplex', unit: 'un', price: 85 },
    { name: 'Disjoncteur GFCI 20A', unit: 'un', price: 48 },
    { name: 'Disjoncteur 2 pôles 30A', unit: 'un', price: 38 },
    { name: 'Disjoncteur 2 pôles 50A', unit: 'un', price: 52 },
    { name: 'Disjoncteur 2 pôles 60A', unit: 'un', price: 78 },
    { name: 'Borne de recharge VE niveau 2 40A', unit: 'un', price: 950 },
    { name: 'Câble VE installation', unit: 'pi.lin.', price: 4.50 },
    { name: 'Génératrice portable 7000W', unit: 'un', price: 1450 },
    { name: 'Commutateur de transfert automatique', unit: 'un', price: 850 },
    { name: 'Ruban chauffant toiture 50\'', unit: 'rouleau', price: 145 },
    { name: 'Bande LED 16\' Wi-Fi', unit: 'un', price: 95 },
    { name: 'Driver LED 24V 100W', unit: 'un', price: 65 },
    { name: 'Caméra de sécurité IP extérieure 4K', unit: 'un', price: 220 },
    { name: 'Thermostat intelligent Nest', unit: 'un', price: 280 },
    { name: 'Thermostat intelligent Ecobee', unit: 'un', price: 320 },
    { name: 'Bouton commande Lutron Caseta', unit: 'un', price: 95 },
    { name: 'Hub d\'automatisation', unit: 'un', price: 180 },
    { name: 'Prise de plancher garage (pieuvre)', unit: 'un', price: 28 },
    { name: 'Lumière garage DEL 60W', unit: 'un', price: 65 },
    { name: 'Détecteur fumée + CO combiné', unit: 'un', price: 78 },
    { name: 'Sirène intérieure intelligente', unit: 'un', price: 95 },
    { name: 'Plinthe électrique 1000W', unit: 'un', price: 65 },
    { name: 'Plinthe électrique 1500W', unit: 'un', price: 85 },
    { name: 'Thermostat électronique de plinthe', unit: 'un', price: 48 },
    { name: 'Interrupteur minuterie', unit: 'un', price: 38 },
    { name: 'Boîte de dérivation avec couvercle', unit: 'un', price: 12 },
    { name: 'Fouet de cuisinière 50A', unit: 'un', price: 45 },
    { name: 'Luminaire DEL 4\' d\'atelier', unit: 'un', price: 55 },
    { name: 'Détecteur d\'inondation intelligent', unit: 'un', price: 65 },
  ],
  'Plomberie': [
    { name: 'Système de filtration central UV', unit: 'un', price: 1850 },
    { name: 'Chauffe-eau pompe à chaleur 65 gal', unit: 'un', price: 2200 },
    { name: 'Chauffe-eau instantané électrique', unit: 'un', price: 980 },
    { name: 'Système caloporteur radiant', unit: 'pi.²', price: 14 },
    { name: 'Boiler propane combiné chauffage', unit: 'un', price: 4500 },
    { name: 'Pompe à eaux usées avec broyeur', unit: 'un', price: 850 },
    { name: 'Membrane d\'imperméabilisation fondation', unit: 'rouleau', price: 320 },
    { name: 'Drain français 4" perforé (longueur 100\')', unit: 'rouleau', price: 180 },
    { name: 'Géotextile NW8 4x100', unit: 'rouleau', price: 145 },
    { name: 'Pompe de puisard 1/3 HP', unit: 'un', price: 280 },
    { name: 'Adoucisseur d\'eau 32 000 grains', unit: 'un', price: 1850 },
    { name: 'Système osmose inversée 5 étapes', unit: 'un', price: 580 },
    { name: 'Réservoir expansion thermique', unit: 'un', price: 95 },
    { name: 'Robinet extérieur antigel', unit: 'un', price: 95 },
    { name: 'Borne d\'arrosage souterraine', unit: 'un', price: 180 },
    { name: 'Trappe d\'accès plomberie 12x12', unit: 'un', price: 28 },
    { name: 'Soupape mélangeuse thermostatique', unit: 'un', price: 145 },
    { name: 'Tuyau ABS 6"', unit: 'pi.lin.', price: 14 },
    { name: 'Raccord union PEX', unit: 'un', price: 14 },
    { name: 'Coude transition PEX-cuivre', unit: 'un', price: 12 },
    { name: 'Sertisseuse PEX (outil)', unit: 'un', price: 580 },
    { name: 'Clapet antiretour d\'égout 4"', unit: 'un', price: 145 },
    { name: 'Bride de toilette 3"', unit: 'un', price: 18 },
    { name: 'Boîte de laveuse encastrée', unit: 'un', price: 65 },
    { name: 'Robinets de laveuse duo', unit: 'un', price: 48 },
    { name: 'Siphon de lavabo chromé 1¼"', unit: 'un', price: 22 },
    { name: 'Flexible tressé inox 3/8" (paire)', unit: 'paire', price: 22 },
    { name: 'Pompe de puisard de secours à eau', unit: 'un', price: 220 },
    { name: 'Anneau de cire avec bride', unit: 'un', price: 12 },
  ],
  'Charpenterie': [
    { name: '6x6x10 traité', unit: 'un', price: 65 },
    { name: 'LVL 1¾x11¼ x 16\'', unit: 'un', price: 165 },
    { name: 'LVL 1¾x14 x 20\'', unit: 'un', price: 280 },
    { name: 'I-Joist 9½" TJI x 16\'', unit: 'un', price: 85 },
    { name: 'I-Joist 11⅞" TJI x 20\'', unit: 'un', price: 145 },
    { name: 'Contreplaqué CDX ¾" 4x8', unit: 'feuille', price: 65 },
    { name: 'Contreplaqué bouleau ¾ premium', unit: 'feuille', price: 95 },
    { name: 'Gypse régulier ½" 4x8', unit: 'feuille', price: 14 },
    { name: 'Gypse résistant à l\'eau ½" 4x8', unit: 'feuille', price: 22 },
    { name: 'Gypse Type X 5/8" 4x8', unit: 'feuille', price: 18 },
    { name: 'Gypse insonorisant QuietRock', unit: 'feuille', price: 65 },
    { name: 'Vis à gypse 1¼" boîte', unit: 'boîte', price: 14 },
    { name: 'Vis à plancher 3" boîte', unit: 'boîte', price: 28 },
    { name: 'Vis structurales GRK RSS 6"', unit: 'boîte', price: 65 },
    { name: 'Clous ordinaires 16d', unit: 'boîte', price: 22 },
    { name: 'Clous gun framing 3¼"', unit: 'boîte', price: 38 },
    { name: 'Étrier double 2x10 Simpson', unit: 'un', price: 14 },
    { name: 'Étrier solive ouragan Simpson H1', unit: 'un', price: 1.80 },
    { name: 'Plaque de jonction Simpson 18ga', unit: 'un', price: 4 },
    { name: 'Pieu d\'ancrage Simpson MASA', unit: 'un', price: 18 },
    { name: 'Coupe-feu polyuréthane (canette)', unit: 'tube', price: 14 },
    { name: 'Adhésif construction PL Premium', unit: 'tube', price: 9 },
    { name: 'Plaque de béton 4x8 ⅜"', unit: 'feuille', price: 26 },
    { name: 'Poteau ajustable en acier (télépost)', unit: 'un', price: 85 },
    { name: 'Linteau d\'acier 3½" x 6\'', unit: 'un', price: 95 },
    { name: 'Colle à sous-plancher PL400', unit: 'tube', price: 8 },
    { name: 'Cales de bois (shims) paquet', unit: 'paquet', price: 6 },
    { name: 'Fourrure métallique 7/8" x 12\'', unit: 'un', price: 9 },
    { name: 'Bande résiliente insonorisante', unit: 'pi.lin.', price: 0.85 },
    { name: 'Profilé Z galvanisé', unit: 'pi.lin.', price: 2.2 },
    { name: 'Connecteur de solive invisible', unit: 'un', price: 6.5 },
  ],
  'Béton et fondation': [
    { name: 'Sac de ciment Portland 30kg', unit: 'sac', price: 14 },
    { name: 'Sac mortier type S 30kg', unit: 'sac', price: 12 },
    { name: 'Sac de mortier réfractaire', unit: 'sac', price: 32 },
    { name: 'Pieu vissé 4½" x 7\'', unit: 'un', price: 320 },
    { name: 'Pieu vissé 6" x 10\'', unit: 'un', price: 480 },
    { name: 'Sonotube 8" x 10\'', unit: 'un', price: 38 },
    { name: 'Sonotube 10" x 12\'', unit: 'un', price: 65 },
    { name: 'Sonotube 12" x 12\'', unit: 'un', price: 95 },
    { name: 'Acier d\'armature #4 (½") 20\'', unit: 'un', price: 14 },
    { name: 'Acier d\'armature #5 (⅝") 20\'', unit: 'un', price: 22 },
    { name: 'Treillis soudé 6x6 W2.9 4x8', unit: 'feuille', price: 28 },
    { name: 'Coffrage Quad-Deck', unit: 'pi.²', price: 8 },
    { name: 'Mastic d\'étanchéité élastomère', unit: 'tube', price: 22 },
    { name: 'Membrane Henry Blueskin VP100', unit: 'rouleau', price: 280 },
    { name: 'Polystyrène extrudé R-10 (2")', unit: 'feuille', price: 38 },
    { name: 'Polystyrène extrudé R-15 (3")', unit: 'feuille', price: 55 },
    { name: 'Couvre-joint élastomère', unit: 'tube', price: 18 },
    { name: 'Béton livré (m³)', unit: 'm.³', price: 240 },
    { name: 'Pompage béton (taxes incluses)', unit: 'm.³', price: 95 },
    { name: 'Coupe-béton diamantée location/jour', unit: 'jour', price: 145 },
    { name: 'Scellant pénétrant béton', unit: 'gallon', price: 95 },
    { name: 'Scie béton circulaire location/jour', unit: 'jour', price: 95 },
    { name: 'Accélérateur de prise (chlorure de calcium)', unit: 'sac', price: 28 },
    { name: 'Composé de cure à béton', unit: 'gallon', price: 48 },
    { name: 'Kit d\'injection époxy pour fissures', unit: 'kit', price: 145 },
    { name: 'Ancrage béton Tapcon 1/4" (boîte 100)', unit: 'boîte', price: 32 },
    { name: 'Pigment colorant pour béton', unit: 'un', price: 38 },
    { name: 'Imperméabilisant cristallin (Xypex)', unit: 'sac', price: 85 },
    { name: 'Treillis en fibre de verre', unit: 'rouleau', price: 65 },
    { name: 'Scellant à fissures de béton', unit: 'tube', price: 14 },
  ],
  'Paysagement': [
    { name: 'Tourbe naturelle (rouleau)', unit: 'rouleau', price: 7 },
    { name: 'Terre noire (sac 30L)', unit: 'sac', price: 5 },
    { name: 'Terre à gazon (verge cube)', unit: 'vg.³', price: 65 },
    { name: 'Compost de feuilles (verge cube)', unit: 'vg.³', price: 55 },
    { name: 'Sable maçon (tonne)', unit: 'tonne', price: 65 },
    { name: 'Pierre concassée 0-3/4 (tonne)', unit: 'tonne', price: 48 },
    { name: 'Pierre décorative 3/4 (tonne)', unit: 'tonne', price: 65 },
    { name: 'Pierre marbre concassée blanche', unit: 'sac', price: 12 },
    { name: 'Paillis cèdre rouge (3 pi³)', unit: 'sac', price: 8 },
    { name: 'Paillis noir teint (3 pi³)', unit: 'sac', price: 6 },
    { name: 'Pavé uni Techo-Bloc Hera', unit: 'pi.²', price: 7 },
    { name: 'Pavé uni Permacon Lafitt', unit: 'pi.²', price: 6 },
    { name: 'Pavé uni perméable', unit: 'pi.²', price: 9 },
    { name: 'Bordure de jardin acier corten', unit: 'pi.lin.', price: 14 },
    { name: 'Mur de soutènement Techo-Bloc Bristol', unit: 'pi.²', price: 28 },
    { name: 'Géogrille renfort mur', unit: 'pi.²', price: 1.80 },
    { name: 'Tunnel drainage NDS', unit: 'pi.lin.', price: 4 },
    { name: 'Cèdre haie blanc 5\'', unit: 'un', price: 65 },
    { name: 'Cèdre haie 6\'', unit: 'un', price: 85 },
    { name: 'Érable rouge 5 gal', unit: 'un', price: 145 },
    { name: 'Lilas commun 5 gal', unit: 'un', price: 85 },
    { name: 'Hortensia 3 gal', unit: 'un', price: 48 },
    { name: 'Vivace assortie 1 gal', unit: 'un', price: 18 },
    { name: 'Système d\'irrigation goutte-à-goutte', unit: 'pi.lin.', price: 2 },
    { name: 'Tête d\'arrosage rotatif', unit: 'un', price: 22 },
    { name: 'Programmateur d\'irrigation 6 zones', unit: 'un', price: 280 },
    { name: 'Bassin préformé 100L', unit: 'un', price: 220 },
    { name: 'Pompe bassin 1000 L/h', unit: 'un', price: 145 },
    { name: 'Clôture cèdre 6\' x 8\' panneau', unit: 'un', price: 145 },
    { name: 'Clôture maille de chaîne 4\' x 50\'', unit: 'rouleau', price: 220 },
    { name: 'Poteau de clôture 4x4x8 traité', unit: 'un', price: 14 },
    { name: 'Pergola cèdre 10x10 kit', unit: 'kit', price: 1850 },
    { name: 'Gazon synthétique', unit: 'pi.²', price: 4.5 },
    { name: 'Marches de pierre naturelle', unit: 'un', price: 145 },
    { name: 'Muret de pierre naturelle', unit: 'pi.²', price: 38 },
    { name: 'Foyer extérieur en blocs (kit)', unit: 'kit', price: 580 },
    { name: 'Éclairage solaire d\'allée (lot 8)', unit: 'lot', price: 85 },
    { name: 'Terre tamisée (verge cube)', unit: 'vg.³', price: 48 },
    { name: 'Capteur de pluie pour irrigation', unit: 'un', price: 45 },
    { name: 'Bordure de béton coulée', unit: 'pi.lin.', price: 12 },
  ],
  'Démolition': [
    { name: 'Surcharge bardeau d\'asphalte', unit: 'tonne', price: 145 },
    { name: 'Surcharge matériau dangereux', unit: 'tonne', price: 280 },
    { name: 'Marteau démolition électrique', unit: 'jour', price: 95 },
    { name: 'Marteau-piqueur pneumatique', unit: 'jour', price: 145 },
    { name: 'Lame scie béton diamantée 14"', unit: 'un', price: 280 },
    { name: 'Lame Sawzall démolition', unit: 'un', price: 9 },
    { name: 'Sac démolition 30 gallons', unit: 'paquet', price: 28 },
    { name: 'Sac sable consigne', unit: 'un', price: 4 },
    { name: 'Protection plancher cartonné 4x8', unit: 'feuille', price: 28 },
    { name: 'Lunettes ANSI Z87+', unit: 'paire', price: 14 },
    { name: 'Casque de chantier CSA', unit: 'un', price: 28 },
    { name: 'Bottes acier CSA', unit: 'paire', price: 145 },
    { name: 'Gants Kevlar coupe-résistant', unit: 'paire', price: 22 },
    { name: 'Demi-masque P100', unit: 'un', price: 65 },
    { name: 'Cartouche P100 (paire)', unit: 'paire', price: 32 },
    { name: 'Harnais de sécurité full body', unit: 'un', price: 145 },
    { name: 'Échafaudage 5\' section', unit: 'un', price: 280 },
    { name: 'Location échafaudage 8\' (semaine)', unit: 'semaine', price: 145 },
    { name: 'Permis de démolition municipal', unit: 'un', price: 280 },
    { name: 'Décontamination amiante (sous-traitance)', unit: 'lot', price: 2800 },
    { name: 'Abat-poussière (barrière ZipWall)', unit: 'kit', price: 220 },
    { name: 'Ventilateur négatif HEPA (location)', unit: 'jour', price: 95 },
    { name: 'Polythène ignifuge (rouleau)', unit: 'rouleau', price: 85 },
    { name: 'Permis d\'occupation pour conteneur (rue)', unit: 'un', price: 145 },
    { name: 'Protection d\'escalier en feutre', unit: 'rouleau', price: 38 },
  ],
  'Agrandissement': [
    { name: 'Fenêtre Energy Star battant 36x48', unit: 'un', price: 580 },
    { name: 'Fenêtre Energy Star battant 48x60', unit: 'un', price: 850 },
    { name: 'Fenêtre triple vitrage 36x48', unit: 'un', price: 1100 },
    { name: 'Porte-fenêtre coulissante 6\'', unit: 'un', price: 1450 },
    { name: 'Porte patio française', unit: 'un', price: 1850 },
    { name: 'Porte entrée acier isolée 36"', unit: 'un', price: 850 },
    { name: 'Porte intérieure 6 panneaux 30"', unit: 'un', price: 145 },
    { name: 'Porte intérieure prémontée bloc 32"', unit: 'un', price: 220 },
    { name: 'Cadre de porte intérieure MDF', unit: 'un', price: 38 },
    { name: 'Quincaillerie poignée passage', unit: 'un', price: 32 },
    { name: 'Quincaillerie poignée verrou', unit: 'un', price: 48 },
    { name: 'Poignée porte d\'entrée multipoint', unit: 'un', price: 280 },
    { name: 'Serrure intelligente Wi-Fi', unit: 'un', price: 380 },
    { name: 'Isolation laine de roche R-22 (12")', unit: 'pi.²', price: 1.20 },
    { name: 'Isolation laine de verre R-12 (3.5")', unit: 'pi.²', price: 0.65 },
    { name: 'Isolation laine de verre R-20 (5.5")', unit: 'pi.²', price: 0.85 },
    { name: 'Polystyrène R-7 (1")', unit: 'pi.²', price: 0.95 },
    { name: 'Mousse uréthane giclée 2lb 2"', unit: 'pi.²', price: 5.50 },
    { name: 'Mousse uréthane giclée 2lb 3"', unit: 'pi.²', price: 7.50 },
    { name: 'Pare-vapeur PE 6mil', unit: 'rouleau', price: 145 },
    { name: 'Ruban Tuck Tape rouge', unit: 'rouleau', price: 18 },
    { name: 'Plans d\'architecte (estimé)', unit: 'lot', price: 4500 },
    { name: 'Ingénieur structure (estimé)', unit: 'lot', price: 2200 },
    { name: 'Membrane insonorisante de plancher', unit: 'pi.²', price: 1.4 },
    { name: 'Échangeur d\'air VRC installé', unit: 'un', price: 2450 },
    { name: 'Escalier extérieur en béton préfab', unit: 'marche', price: 220 },
    { name: 'Seuil de porte extérieure aluminium', unit: 'un', price: 48 },
    { name: 'Solin de porte-patio', unit: 'kit', price: 38 },
    { name: 'Poutrelle ajourée installée', unit: 'pi.lin.', price: 12 },
  ],
  'Climatisation et thermopompes': [
    { name: 'Thermopompe murale 12000 BTU Mitsubishi', unit: 'un', price: 2850 },
    { name: 'Thermopompe murale 18000 BTU Mitsubishi', unit: 'un', price: 3450 },
    { name: 'Thermopompe murale 24000 BTU Mitsubishi', unit: 'un', price: 3950 },
    { name: 'Thermopompe murale 12000 BTU Daikin', unit: 'un', price: 2650 },
    { name: 'Thermopompe murale 9000 BTU Fujitsu', unit: 'un', price: 2450 },
    { name: 'Thermopompe centrale 2 tonnes', unit: 'un', price: 4800 },
    { name: 'Thermopompe centrale 3 tonnes', unit: 'un', price: 5800 },
    { name: 'Thermopompe centrale 4 tonnes', unit: 'un', price: 6800 },
    { name: 'Climatiseur fenêtre 10000 BTU', unit: 'un', price: 480 },
    { name: 'Climatiseur portable 14000 BTU', unit: 'un', price: 680 },
    { name: 'Conduite frigorifique 1/4-1/2 25\'', unit: 'kit', price: 320 },
    { name: 'Console linéaire évaporateur', unit: 'un', price: 220 },
    { name: 'Support mural unité extérieure', unit: 'un', price: 145 },
    { name: 'Plate-forme béton unité extérieure', unit: 'un', price: 95 },
    { name: 'Disjoncteur dédié 30A bi-pôle', unit: 'un', price: 65 },
    { name: 'Couvercle conduit extérieur', unit: 'pi.lin.', price: 18 },
    { name: 'Thermostat thermopompe Wi-Fi', unit: 'un', price: 320 },
    { name: 'Échangeur d\'air (VRC) Venmar', unit: 'un', price: 1850 },
    { name: 'Échangeur d\'air HVE haute efficacité', unit: 'un', price: 2450 },
    { name: 'Conduit flexible isolé 6"', unit: 'pi.lin.', price: 12 },
    { name: 'Grille ventilation 6x12', unit: 'un', price: 22 },
    { name: 'Diffuseur plafonnier rond 6"', unit: 'un', price: 38 },
    { name: 'Filtre HEPA fournaise', unit: 'un', price: 95 },
    { name: 'Service entretien climatisation', unit: 'un', price: 220 },
    { name: 'Subvention Énergir/Hydro-Québec (à déduire)', unit: 'un', price: -1200 },
    { name: 'Fournaise électrique 15 kW', unit: 'un', price: 1850 },
    { name: 'Fournaise électrique 20 kW', unit: 'un', price: 2200 },
    { name: 'Thermopompe multi-zones 2 têtes', unit: 'un', price: 5200 },
    { name: 'Plénum de fournaise sur mesure', unit: 'un', price: 380 },
    { name: 'Humidificateur central', unit: 'un', price: 320 },
    { name: 'Nettoyage de conduits (service)', unit: 'un', price: 380 },
  ],
  'Isolation': [
    { name: 'Uréthane giclé closed-cell 2lb 2"', unit: 'pi.²', price: 5.50 },
    { name: 'Uréthane giclé closed-cell 2lb 4"', unit: 'pi.²', price: 9.50 },
    { name: 'Uréthane giclé closed-cell 2lb 6"', unit: 'pi.²', price: 13 },
    { name: 'Cellulose soufflée grenier R-50', unit: 'pi.²', price: 2.20 },
    { name: 'Laine de roche Rockwool R-23 5.5"', unit: 'pi.²', price: 1.10 },
    { name: 'Laine de roche Comfortbatt R-30', unit: 'pi.²', price: 1.85 },
    { name: 'Panneau acoustique SONOpan', unit: 'feuille', price: 32 },
    { name: 'Polyisocyanurate R-12 (2")', unit: 'feuille', price: 48 },
    { name: 'Mousse Hilti expansion joints', unit: 'tube', price: 22 },
    { name: 'Ruban pare-vapeur Tuck Tape', unit: 'rouleau', price: 18 },
    { name: 'Scellant acoustique Tremco', unit: 'tube', price: 9 },
    { name: 'Ventilateur extraction grenier solaire', unit: 'un', price: 480 },
    { name: 'Test infiltrométrie blower door', unit: 'un', price: 380 },
    { name: 'Caméra thermographie inspection', unit: 'un', price: 480 },
    { name: 'Programme Rénoclimat (consultation)', unit: 'un', price: 380 },
    { name: 'Laine soufflée de verre R-40 grenier', unit: 'pi.²', price: 1.8 },
    { name: 'Scellage portes et fenêtres à l\'uréthane', unit: 'un', price: 180 },
    { name: 'Isolation des solives de rive à l\'uréthane', unit: 'pi.lin.', price: 6.5 },
    { name: 'Natte insonorisante (rouleau)', unit: 'rouleau', price: 85 },
    { name: 'Laine de verre R-24 murs 2x6', unit: 'pi.²', price: 1.05 },
    { name: 'Pare-vapeur intelligent (MemBrain)', unit: 'rouleau', price: 185 },
  ],
  'Excavation et drainage': [
    { name: 'Excavation tranchée fondation/h', unit: 'heure', price: 145 },
    { name: 'Location mini-pelle 5 tonnes/jour', unit: 'jour', price: 480 },
    { name: 'Location mini-pelle 8 tonnes/jour', unit: 'jour', price: 680 },
    { name: 'Location bulldozer compact/jour', unit: 'jour', price: 580 },
    { name: 'Location compacteur plaque', unit: 'jour', price: 145 },
    { name: 'Location niveleuse laser', unit: 'jour', price: 95 },
    { name: 'Transport remblai (tonne)', unit: 'tonne', price: 45 },
    { name: 'Disposition terre/roche/m³', unit: 'm.³', price: 85 },
    { name: 'Drain agricole 4" perforé/100\'', unit: 'rouleau', price: 95 },
    { name: 'Drain agricole 6" perforé/100\'', unit: 'rouleau', price: 185 },
    { name: 'Fosse drain français 4 chambres', unit: 'kit', price: 1450 },
    { name: 'Bassin de rétention 220 gal', unit: 'un', price: 580 },
    { name: 'Membrane Delta-MS protection fond.', unit: 'rouleau', price: 220 },
    { name: 'Imperméabilisant goudron fondation', unit: 'gallon', price: 65 },
    { name: 'Test percolation terrain (Q-2 r.22)', unit: 'un', price: 850 },
    { name: 'Étude de sol/géotechnique', unit: 'lot', price: 1850 },
    { name: 'Permis d\'occupation domaine public', unit: 'un', price: 380 },
    { name: 'Localisation services publics Info-Excavation', unit: 'un', price: 0 },
    { name: 'Pierre nette 3/4" (tonne)', unit: 'tonne', price: 52 },
    { name: 'Sable compactable (tonne)', unit: 'tonne', price: 42 },
    { name: 'Puisard extérieur avec grille', unit: 'un', price: 145 },
    { name: 'Nivellement final du terrain', unit: 'heure', price: 125 },
    { name: 'Membrane géotextile pour bassin', unit: 'pi.²', price: 1.2 },
  ],
  'Terrasse et patio': [
    { name: 'Composite Trex Enhance 16\'', unit: 'pi.lin.', price: 14 },
    { name: 'Composite TimberTech AZEK 16\'', unit: 'pi.lin.', price: 22 },
    { name: 'Cèdre rouge clear 5/4x6x16\'', unit: 'pi.lin.', price: 9 },
    { name: 'Pin traité 5/4x6x16\'', unit: 'pi.lin.', price: 5 },
    { name: 'Ipe (bois exotique) 5/4x6x16\'', unit: 'pi.lin.', price: 18 },
    { name: 'Pieu vissé terrasse 6\'', unit: 'un', price: 220 },
    { name: 'Solive 2x8x12 traité', unit: 'un', price: 28 },
    { name: 'Poutre 3 plis 2x10x16 traité', unit: 'lot', price: 145 },
    { name: 'Vis Camo (boîte 350)', unit: 'boîte', price: 65 },
    { name: 'Clips invisibles composite', unit: 'boîte', price: 95 },
    { name: 'Garde-corps aluminium pré-fab 6\'', unit: 'un', price: 380 },
    { name: 'Garde-corps verre 6\' panneau', unit: 'un', price: 580 },
    { name: 'Garde-corps câble inox kit 6\'', unit: 'un', price: 480 },
    { name: 'Escalier composite préfabriqué', unit: 'marche', price: 145 },
    { name: 'Toiture toile rétractable 10x12', unit: 'un', price: 2850 },
    { name: 'Toiture motorisée pergola', unit: 'pi.²', price: 95 },
    { name: 'Auvent rétractable 12\' motorisé', unit: 'un', price: 2200 },
    { name: 'Spa 6 places acrylique installation', unit: 'un', price: 12500 },
    { name: 'Foyer gaz extérieur table', unit: 'un', price: 1450 },
    { name: 'Cuisine extérieure module', unit: 'pi.lin.', price: 950 },
    { name: 'Pavé chauffant patio chaufferette', unit: 'pi.²', price: 32 },
    { name: 'Éclairage DEL patio 12V (kit 10)', unit: 'kit', price: 320 },
    { name: 'Bloc de patio (deck block)', unit: 'un', price: 12 },
    { name: 'Lisse d\'ancrage au mur (ledger) 2x10', unit: 'pi.lin.', price: 4.5 },
    { name: 'Jupe de terrasse (treillis)', unit: 'feuille', price: 32 },
    { name: 'Limon d\'escalier 4 marches', unit: 'un', price: 28 },
    { name: 'Teinture à terrasse (gallon)', unit: 'gallon', price: 55 },
    { name: 'Luminaire de poteau solaire', unit: 'un', price: 28 },
  ],
  'Garage et atelier': [
    { name: 'Porte de garage isolée 16x7 R-16', unit: 'un', price: 1850 },
    { name: 'Porte de garage isolée 9x7 R-16', unit: 'un', price: 1100 },
    { name: 'Porte de garage double isolée 16x8', unit: 'un', price: 2200 },
    { name: 'Ouvre-porte garage 1/2HP Liftmaster', unit: 'un', price: 480 },
    { name: 'Ouvre-porte garage Wi-Fi MyQ', unit: 'un', price: 580 },
    { name: 'Coupe-froid porte garage', unit: 'pi.lin.', price: 4.50 },
    { name: 'Plancher époxy garage kit 250 pi²', unit: 'kit', price: 380 },
    { name: 'Plancher époxy paillette pro/pi²', unit: 'pi.²', price: 9 },
    { name: 'Rangement mural pegboard 4x8', unit: 'feuille', price: 95 },
    { name: 'Cabinet d\'atelier acier 36"', unit: 'un', price: 580 },
    { name: 'Établi commercial 6\'', unit: 'un', price: 480 },
    { name: 'Compresseur 30 gal 240V', unit: 'un', price: 850 },
    { name: 'Aspirateur central garage', unit: 'un', price: 580 },
    { name: 'Chauffage suspendu gaz 60000 BTU', unit: 'un', price: 850 },
    { name: 'Chauffage électrique infrarouge', unit: 'un', price: 480 },
    { name: 'Lumière garage DEL haute baie', unit: 'un', price: 145 },
    { name: 'Rangement plafond rétractable', unit: 'un', price: 380 },
    { name: 'Tablette acier garage 48"', unit: 'un', price: 145 },
    { name: 'Drain de garage avec grille', unit: 'un', price: 85 },
    { name: 'Seuil de porte de garage en caoutchouc', unit: 'pi.lin.', price: 8 },
    { name: 'Panneau slatwall PVC 4x8', unit: 'feuille', price: 145 },
    { name: 'Support à vélos au plafond', unit: 'un', price: 48 },
    { name: 'Peinture de lignes de stationnement', unit: 'pot', price: 32 },
  ],
};

// English translations for new work types
export const EN_EXTRA_KEYS = {
  'Climatisation et thermopompes': 'HVAC and heat pumps',
  'Isolation': 'Insulation',
  'Excavation et drainage': 'Excavation and drainage',
  'Terrasse et patio': 'Deck and patio',
  'Garage et atelier': 'Garage and workshop',
};
